import script from "./LiveCaption.vue?vue&type=script&setup=true&lang=ts"
export * from "./LiveCaption.vue?vue&type=script&setup=true&lang=ts"

import "./LiveCaption.vue?vue&type=style&index=0&id=47baddd6&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-47baddd6"]])

export default __exports__